import styled from 'styled-components';
import { ActionButtonState } from '.';

interface BaseProps {
	state: ActionButtonState;
	colors?: {
		disabled?: string;
		hover?: string;
		active?: string;
		selected?: string;
		border?: string;
		text?: string;
	};
	isMobile?: boolean;
}

export const Base = styled.button<BaseProps>`
	// layout
	display: flex;
	align-items: center;
	justify-content: center;
	height: 30px;
	padding: 2px 6px 0 6px;
	border: 1px solid ${({ theme, colors }) => colors?.border || theme.gray[200]};
	border-radius: 4px;
	outline: none;
	cursor: pointer;
	transform: ${({ isMobile }) => (isMobile ? 'scale(1.3)' : 'scale(1)')};
	transform-origin: center;

	// style based on state
	background-color: ${({ state, theme, colors }) => {
		if (state === ActionButtonState.DISABLED) {
			return colors?.disabled || theme.gray[400];
		}
		if (state === ActionButtonState.SELECTED) {
			return colors?.selected || theme.blue[500];
		}
		return 'transparent';
	}};

	&:hover {
		background-color: ${({ state, theme, colors }) => {
			if (state === ActionButtonState.DISABLED) {
				return colors?.disabled || theme.gray[400];
			}
			if (state === ActionButtonState.SELECTED) {
				return colors?.selected || theme.blue[500];
			}
			return colors?.hover || theme.gray[200];
		}};
	}

	&:active {
		background-color: ${({ state, theme, colors }) => {
			if (state === ActionButtonState.DISABLED) {
				return colors?.disabled || theme.gray[400];
			}
			if (state === ActionButtonState.SELECTED) {
				return colors?.selected || theme.blue[500];
			}
			return colors?.active || theme.gray[100];
		}};
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const Icon = styled.div`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
`;

export const Label = styled.div`
	font-size: 11px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	padding-left: 4px;
	padding-right: 4px;
	padding-bottom: 2px;
	pointer-events: none;
`;
